module.exports = __webpack_public_path__ + "img/ic_64_logo.02251b42.svg";